import { Component, EventEmitter, Input, Output } from '@angular/core';
import { validateRanges } from '../nightingale.helpers';

@Component({
  selector: 'app-add-annotations',
  templateUrl: './add-annotations.component.html',
  styleUrl: './add-annotations.component.css',
  standalone: false
})
export class AddAnnotationsComponent {
  trackName = '';
  residueRanges = '';

  trackNameError = '';
  residueRangesErrors: string[] = [];
  
  @Input() sequenceLength: number;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() addAnnotations: EventEmitter<Object> = new EventEmitter();

  // Called live when typing residue ranges
  onResidueRangesInput() {
    const { isValid, messages } = validateRanges({ start: 1, end: this.sequenceLength }, this.residueRanges);
    this.residueRangesErrors = isValid ? [] : messages;
  }
  
  addTrack() {
    this.trackNameError = '';
    this.residueRangesErrors = [];

    // Validate both fields
    if (!this.trackName.trim()) {
      this.trackNameError = 'Please enter track name';
    }

    const { isValid, messages } = validateRanges({ start: 1, end: this.sequenceLength }, this.residueRanges);
    if (!isValid) {
      this.residueRangesErrors = messages;
    }

    // If all valid, emit the event
    if (!this.trackNameError && this.residueRangesErrors.length === 0) {
      this.addAnnotations.emit({"trackName": this.trackName,  "residueRanges": this.residueRanges});
    }
  }

  onClose() {
    this.closeDialog.emit();
  }
}
